import PaymentRequestModal from './Modal/PaymentRequestModal'
import PaymentDeleteModal from './Modal/PaymentDeleteModal'
import ViewPaymentReqModal from './Modal/ViewPaymentReqModal'
import {KTCard, KTIcon} from '../../../_metronic/helpers'
import {usePaymentProvider} from './PaymentProvider'
import PaymentListFilter from './PaymentListFilter'
import {ListViewContext, useListView} from './core/ListViewProvider'
import SelectList from './SelectList'
import TableContent from '../../utils/components/Table/TableContent'
import {PaymentColumns} from './PaymentColumns'
import TablePagination from '../../utils/components/Table/TablePagination'
import {useAuth} from '../auth'
import {useUserStateProvider} from '../../utils/contextProvider/UserStateProvider'
import NumberFlow from '@number-flow/react'
import continuous from '@number-flow/react'
import InputSearchBox from '../../utils/components/form/InputSearchBox'

const PaymentRequest = () => {
  const {currentUser} = useAuth()
  const {
    isLoading,
    searchTerm,
    setSearchTerm,
    setUpdatePayment,
    setShowModal,
    totalElement,
    itemsPerPage,
    currentPage,
    handlePageChange,
    setFileBlob,
    filteredReq,
    onExport,
  } = usePaymentProvider()

  const {selected} = useListView()
  const {balance} = useUserStateProvider()

  return (
    <>
      <h3 className='fs-2hx my-8 text-center'>
        Current Balance:{' '}
        {balance && (
          <NumberFlow willChange plugins={[continuous]} value={balance.balance} locales='en-US' />
        )}{' '}
        BDT
      </h3>

      <KTCard className='card mb-5 mb-xl-10'>
        <div className='card-header border-0 cursor-pointer'>
          <div className='card-title m-0'>
            <h3 className='er my-4 fs-2x fw-medium'>Payment Request</h3>
          </div>

          <div className='card-title m-0'></div>
        </div>
        <div className='card-header gap-4 align-items-center flex-wrap'>
          <InputSearchBox
            placeholder='Search'
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
          />

          <div className='d-flex gap-2 flex-wrap'>
            {selected.length > 0 ? (
              <SelectList context={ListViewContext} />
            ) : (
              <>
                <PaymentListFilter />
                <button type='button' className='btn btn-success me-3' onClick={onExport}>
                  <KTIcon iconName='exit-up' className='fs-2' />
                  Export
                </button>
                <button
                  type='button'
                  className='btn btn-primary'
                  data-bs-toggle='modal'
                  data-bs-target='#kt_modal_1'
                  onClick={() => {
                    setUpdatePayment(undefined)
                    setShowModal(true)
                    setFileBlob('')
                  }}
                >
                  <KTIcon iconName='plus' className='fs-2' />
                  Create Payment
                </button>
              </>
            )}
          </div>
        </div>
        {/* <TestTable>
        <ListPagination
          totalElement={totalElement}
          itemsPerPage={itemsPerPage}
          currentPage={currentPage}
          handlePageChange={handlePageChange}
          isLoading={isLoading}
        />
      </TestTable> */}

        <TableContent isLoading={isLoading} tableData={filteredReq} tableColumn={PaymentColumns}>
          <TablePagination
            totalElement={totalElement}
            itemsPerPage={itemsPerPage}
            currentPage={currentPage}
            handlePageChange={handlePageChange}
            isLoading={isLoading}
          />
        </TableContent>

        <PaymentRequestModal />

        <ViewPaymentReqModal />

        <PaymentDeleteModal />
      </KTCard>
    </>
  )
}

export default PaymentRequest
